<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='exportBtn'         prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Software.export")'         :click='notify' eventType='export'></e-item>
        <e-item v-if='exportTemplateBtn' prefixIcon='icon hero-icon hero-icon-export-template' :tooltipText='$t("Software.exporttemplate")' :click='notify' eventType='exportTemplate'></e-item>
        <e-item v-if='importBtn'         prefixIcon='icon hero-icon hero-icon-import' :tooltipText='$t("Software.import")'         :click='notify' eventType='import'></e-item>
        <e-item v-if='deleteBtn'         prefixIcon='icon hero-icon hero-icon-clear' :tooltipText='$t("Software.delete")'         :click='notify' eventType='delete'></e-item>
        <e-item v-if='refreshBtn'        prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Software.refresh")'        :click='notify' eventType='refresh'></e-item>
        <e-item v-if='detailBtn'        prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("Software.td_detail")'        :click='notify' eventType='detail'></e-item>
      </e-items>
    </ejs-toolbar>
    <div v-if='keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder ='$t("Software.pleaseEnterTheQueryCriteria")' @input ='updateKeywords' @keydown.native.enter='keydownFunc'></ejs-textbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DistributeMenuButton',
  props: {
    refreshBtn: { type: Boolean, default: false },
    exportBtn: { type: Boolean, default: false },
    exportTemplateBtn: { type: Boolean, default: false },
    importBtn: { type: Boolean, default: false },
    deleteBtn: { type: Boolean, default: false },
    keywordsInput: { type: Boolean, default: false },
    detailBtn: { type: Boolean, default: false }
  },
  data() {
    return {
      queryConditions: {
        keywords: '', // 模糊查询关键字
      },
    };
  },
  computed: {},
  methods: {
    notify(args) {
      if (args.item.eventType === 'refresh') {
        this.queryConditions.keywords = '';
      }
      this.$emit('notify', args.item.eventType);
    },
    subscriptionFunc() {
      this.$emit('notify', 'refresh');
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc(clickEvent) {
      this.$emit('notify', 'keywords');
    },
  },
};
</script>>
